<script>
    import { getContext } from 'svelte';
    import { Policy } from "@Store";
    import Question from "@components/Question.svelte";
    import { validatePropertyDetails, getAnswerText } from "@helpers/validator";
    import { propertyQuestions } from "@helpers/questions";

    const CONTEXT = getContext('CONTEXT');

    // Call the function to get the questions object
    $: questionsList = propertyQuestions($Policy);

    $: needs_property = getAnswerText($Policy, questionsList.additional_insureds_question) === 'yes';
    function handleAnswer(e) {
        CONTEXT.handleAnswer(e);
    }

    $: valid = validatePropertyDetails($Policy);  

    $: {
        CONTEXT.routeValidation.update(validation => ({
            ...validation,
            additionalinsureds: valid
        }));
    }
</script>

<div>
    {#if questionsList.additional_insureds_question}
        <Question question={questionsList.additional_insureds_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
    {/if}
    {#if needs_property}
        {#if questionsList.name_question}
            <Question question={questionsList.name_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}
        {#if questionsList.address_question}
            <Question question={questionsList.address_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}
        
    {/if}
</div>